
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class StagesDialog extends Serenity.EntityDialog<StagesRow, any> {
        protected getFormKey() { return StagesForm.formKey; }
        protected getIdProperty() { return StagesRow.idProperty; }
        protected getLocalTextPrefix() { return StagesRow.localTextPrefix; }
        protected getNameProperty() { return StagesRow.nameProperty; }
        protected getService() { return StagesService.baseUrl; }
        protected getDeletePermission() { return StagesRow.deletePermission; }
        protected getInsertPermission() { return StagesRow.insertPermission; }
        protected getUpdatePermission() { return StagesRow.updatePermission; }

        protected form = new StagesForm(this.idPrefix);
        constructor() {
            super();
            q.hideEditorLabel(this.form.Members);
        }
    }
}